import type { SocialImportPlace } from '@/utils/inspoImportBuilder';

/**
 * Returns the country appearing most often across the given places. Null and
 * empty countries are excluded from the vote. Ties are broken by first-selected
 * (the winning country is the one whose first place appears earliest in the
 * input array). Returns null when no place has a country.
 */
export function pickDominantCountry(places: ReadonlyArray<Pick<SocialImportPlace, 'country'>>): string | null {
  const counts = new Map<string, { count: number; firstIndex: number }>();
  for (let i = 0; i < places.length; i += 1) {
    const raw = places[i]?.country;
    if (!raw) continue;
    const country = raw.trim();
    if (!country) continue;
    const existing = counts.get(country);
    if (existing) {
      existing.count += 1;
    } else {
      counts.set(country, { count: 1, firstIndex: i });
    }
  }
  if (counts.size === 0) return null;

  let winner: string | null = null;
  let winnerCount = -1;
  let winnerFirstIndex = Number.POSITIVE_INFINITY;
  for (const [country, { count, firstIndex }] of counts) {
    if (count > winnerCount || (count === winnerCount && firstIndex < winnerFirstIndex)) {
      winner = country;
      winnerCount = count;
      winnerFirstIndex = firstIndex;
    }
  }
  return winner;
}
